import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./Layouts/Navbar";
import Dashboard from "./Pages/Dashboard";
import Login from "./Pages/LoginPage";
import AboutPage from "./Pages/About";
import Registration from "./Pages/RegistrationPage";
import { Courses } from "./Pages/Courses";
import { Subject } from "./Pages/Subject";
import InstructorNavbar from "./Layouts/InstructorNavbar";
import InstructorDashboard from "./InstructorPages/Dashboard";
import { InstructorCourses } from "./InstructorPages/Courses";
import { InstructorSubject } from "./InstructorPages/Subjects";
import Recording from "./Pages/Recording";
import InstructorRecording from "./InstructorPages/Recording";
import MainPage from "./Pages/Main";
import Submissions from "./InstructorPages/Submissions";
import AdminLogin from "./AdminPages/AdminLogin";
import AdminNavbar from "./Layouts/AdminNavbar";
import AdminDashboard from "./AdminPages/AdminDashboard";
import AdminMaintenance from "./AdminPages/AdminMaintenance";
import InstructorMaintenance from "./AdminPages/InstructorMaintenance";
import StudentMaintenance from "./AdminPages/StudentMaintenance";
import Tickets from "./Pages/Tickets";
import AdminTickets from "./AdminPages/AdminTickets";
import AdminCourses from "./AdminPages/AdminCourses";
import Marks from "./Pages/Marks";
import InstructorNotices from "./InstructorPages/Notices";
import AdminNotices from "./AdminPages/AdminNotices";
import AdminNotifications from "./AdminPages/AdminNotifications";
import AdminInstitutionUpdate from "./AdminPages/AdminInstitutionUpdate";
import Chats from "./Pages/Chats";
import InstructorChats from "./InstructorPages/InstructorChats";
import Notifications from "./Pages/Notifications";
import Attendance from "./Pages/Attendance";
import AdminChats from "./AdminPages/AdminChats";
import Profile from "./Pages/Profile";
import InstructorProfile from "./InstructorPages/Profile";
import AdminProfile from "./AdminPages/Profile";

const App: React.FC = () => {
  const location = useLocation();
  const isMainPage = location.pathname === "/";
  const isLoginPage = location.pathname === "/login";
  const isAdminLoginPage = location.pathname === "/admin-login";
  const isRegistrationPage = location.pathname === "/register";
  const isInstructorPath = location.pathname.startsWith("/instructor");
  const isAdminPath = location.pathname.startsWith("/admin")

  return (
    <div style={{ backgroundColor: "black", height: "100vh", color: "white" }}>
      {isLoginPage || isRegistrationPage || isMainPage || isAdminLoginPage ? (
        <Routes>
          <Route path="/" element={<MainPage/>}/>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Registration />} />
          <Route path="/admin-login" element={<AdminLogin />} />
        </Routes>
      ) : isInstructorPath ? (
        <InstructorNavbar>
          <Routes>
            <Route path="/instructor/instructor-dashboard" element={<InstructorDashboard />} />
            <Route path="/instructor/instructor-courses" element={<InstructorCourses />} />
            <Route path="/instructor/instructor-subject" element={<InstructorSubject />} />
            <Route path="/instructor/instructor-recording" element={<InstructorRecording />} />
            <Route path="/instructor/instructor-submissions" element={<Submissions />} />
            <Route path="/instructor/instructor-notices" element={<InstructorNotices />} />
            <Route path="/instructor/instructor-chats" element={<InstructorChats />} />
            <Route path="/instructor/instructor-profile" element={<InstructorProfile />} />
          </Routes>
        </InstructorNavbar>
      ) : isAdminPath ? (
        <AdminNavbar>
          <Routes>
            <Route path="/admin/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/admin/users/admins" element={<AdminMaintenance />} />
            <Route path="/admin/users/instructors" element={<InstructorMaintenance />} />
            <Route path="/admin/users/students" element={<StudentMaintenance />} />
            <Route path="/admin/tickets" element={<AdminTickets />} />
            <Route path="/admin/courses" element={<AdminCourses />} />
            <Route path="/admin/notices" element={<AdminNotices />} />
            <Route path="/admin/notifications" element={<AdminNotifications />} />
            <Route path="/admin/institution-updates" element={<AdminInstitutionUpdate />} />
            <Route path="/admin/admin-chats" element={<AdminChats />} />
            <Route path="/admin/profile" element={<AdminProfile />} />
          </Routes>
        </AdminNavbar>
      ) :
       (
        <Navbar>
          <Routes>
            <Route path="/courses" element={<Courses />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/subject" element={<Subject />} />
            <Route path="/recording" element={<Recording />} />
            <Route path="/tickets" element={<Tickets />} />
            <Route path="/marks" element={<Marks />} />
            <Route path="/chats" element={<Chats />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/attendance" element={<Attendance />} />
            <Route path="/profile" element={<Profile />} />
          </Routes>
        </Navbar>
      )}
    </div>
  );
};

export default App;
